import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TradingPage from "./pages/TradingPage";
import SecurityPage from "./pages/SecurityPage";
import WholesalePage from "./pages/WholesalePage";
import SpecSheetPage from "./pages/SpecSheetPage";
import OriginPage from "./pages/OriginPage";
import OfferPage from "./pages/OfferPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import EnquiriesPanel from "./pages/admin/EnquiriesPanel";
import CuppingPanel from "./pages/admin/CuppingPanel";
import OffersPanel from "./pages/admin/OffersPanel";
import NewOfferPage from "./pages/admin/NewOfferPage";
import { AuthProvider } from "./context/AuthContext";
import { AuthCallback, ProtectedRoute } from "./components/AuthGate";
import { usePageTitle } from "./hooks/usePageTitle";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const location = useLocation();
  usePageTitle();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Navigate to="/trading/coffee" replace />} />
        <Route path="/trading" element={<Navigate to="/trading/coffee" replace />} />
        <Route path="/trading/:commodity" element={<TradingPage />} />
        <Route path="/origins/:commodity/:slug" element={<OriginPage />} />
        <Route path="/wholesale" element={<WholesalePage />} />
        <Route path="/spec/:commodity/:lot" element={<SpecSheetPage />} />
        <Route path="/offer/:token" element={<OfferPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<EnquiriesPanel />} />
          <Route path="cupping" element={<CuppingPanel />} />
          <Route path="offers" element={<OffersPanel />} />
          <Route path="offers/new/:enquiryId" element={<NewOfferPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/trading/coffee" replace />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
